import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: '', redirectTo: 'pools', pathMatch: 'full' },

  { path: 'pools', data: { preload: true }, loadChildren: () => import('@cbui/modules/pools/pools.routes').then(m => m.default) },
  { path: 'freeplay', data: { preload: false }, loadChildren: () => import('@cbui/modules/freeplay/freeplay.routes').then(m => m.default) },
  { path: 'syndicates', data: { preload: false }, loadChildren: () => import('@cbui/modules/syndicates/syndicates.routes').then(m => m.default) },
  { path: 'tickets', data: { preload: false }, loadChildren: () => import('@cbui/modules/tickets/tickets.routes').then(m => m.default) },
  { path: 'results', loadChildren: () => import('@cbui/modules/results/results.routes').then(m => m.default) },
  { path: 'help', data: { preload: false }, loadChildren: () => import('@cbui/modules/help/help.routes').then(m => m.default) },
  { path: 'errors', data: { preload: false }, loadChildren: () => import('@cbui/modules/errors/errors.routes').then(m => m.default) },

  { path: '**', redirectTo: '/' }
];
